// document ready, vanilla
document.addEventListener("DOMContentLoaded", function () {
    // Get the current full url
    var currentUrl = window.location.href;
    console.log(currentUrl);

    if (currentUrl.includes("ref=b2b") || currentUrl.includes("b2b")) {
        var urlItems = document.querySelectorAll("[data-variant-url]");

        urlItems.forEach(function (element) {
            if (element.href.includes("page=")) {
                element.href = element.href + "&ref=b2b";
            } else {
                element.href = element.href + "?ref=b2b";
            }
        });

        return;
    }
    var elementsToShow = document.querySelectorAll("[data-b2b-hide]");

    // Remove the elements
    elementsToShow.forEach(function (element) {
        element.classList.remove("hidden");
    });
});
